import * as React from 'react';
import { Parallax } from 'react-scroll-parallax';
import Button from '../../../../components/Button';
import CardCarousel from '../../../../components/CardCarousel';

import './style.scss';

const CaseStudiesSection = () => {
  return (
    <section className="l-case-studies-section">
      <Parallax className="background" y={[-30, 30]}>
        <div className="bg1" />
      </Parallax>

      <div className="container">
        <h2 className="section-title">Case Studies</h2>
        <CardCarousel>
          <div className="card">
            <div className="title">
              A new application Framework with many benefits
            </div>
            <div className="content">
              In 2019, the Councils set out to redesign the way in which associations apply for a professional standards
              scheme.
              The delivery of this work represents a major outcome for the Councils on a core regulatory responsibility.
              The project followed human-centred design principles, engaged with key stakeholders in co-design, and
              utilised agile project management philosophy to produce a new Scheme Application Framework to a Pilot
              phase.
            </div>
            <Button color="primary" label="Find out more" icon="link" annualReportPage={21} />
          </div>

          <div className="card">
            <div className="title">
              For the first time, the Councils enable the creation of a scheme for strata managers
            </div>
            <div className="content">
              In April 2021, the Councils approved the Strata Community Association (NSW) Limited Professional Standards
              Scheme, expanding the national system for professional standards regulation to include, for the first
              time, strata managers and the users of their services.
              Strata Community Association (NSW) considers their achievement of a professional standards scheme as one
              of the most significant milestones in their Association’s 40-year history. Applying for a scheme was seen
              as transformational for their members in the recognition of improving occupational standards and consumer
              protection in the strata marketplace.
            </div>
            <Button color="primary" label="Find out more" icon="link" annualReportPage={47} />
          </div>

          <div className="card">
            <div className="title">
              A consumer protection lens: Sexual harassment risks in the legal profession
            </div>
            <div className="content">
              The Councils engaged with associations, legal services regulators, and academics to bring into focus the
              consumer protection and ethics issues involved in sexual harassment. The Councils identify and report on
              trends and emerging issues to assist efforts to improve professional standards.
            </div>
            <Button color="primary" label="Find out more" icon="link" annualReportPage={70} />
          </div>
        </CardCarousel>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
